<template>
	<CharacteristicEdit
		ref="edit"
		:value="value"
		:characteristic-items="meta.skill"
		:characteristic-type="meta.skillType"
		:nothing-allowed="{
			onlyOverall: true,
			overall: {
				inFan: true,
				text: 'Ich habe keine der angegebenen Persönlichkeitseigenschaften / Sozialen Kompetenzen'
			}
		}"
		:selected-items-config="{
			styling: selectedItemsStylingList
		}"
		open-fan-label="Persönlichkeitseigenschaften / Soziale Kompetenzen hinzufügen/bearbeiten"
		title="Persönlichkeitseigenschaften / Soziale Kompetenzen"
		:with-edit-button="withEditButton"
		:header-info="headerInfo"
		:completion-check-config="{
			enabled: true,
			label: 'Persönlichkeitseigenschaften / Soziale Kompetenzen',
			okButtonText: 'Ich habe keine weiteren',
			popUpInfo: completionCheckInfo
		}"
		@input="$emit('input', $event)"
		@finish="$emit('finish', $event)"
	/>
</template>

<script>
import {mapState} from "vuex";
import CharacteristicEdit from "@/vue/characteristic/Edit";
import {STYLING__LIST} from "@/vue/characteristic/SelectedItems"
import {HEADER_INFO__APPLICATION_NO_EXPERIENCE} from "@/vue/characteristic/Fan.vue";
import {APPLICATION_SKILL} from "@/helper/characteristic/completion-check/Info";

export default {

	components: {
		CharacteristicEdit,
	},

	props: {
		value: {
			type: Array,
			required: false,
		},
		withEditButton: {
			type: Boolean,
			required: false,
			default: true,
		},
	},

	computed: {
		...mapState('meta', ['meta']),
		selectedItemsStylingList ()
		{
			return STYLING__LIST;
		},
		headerInfo ()
		{
			return HEADER_INFO__APPLICATION_NO_EXPERIENCE;
		},
		completionCheckInfo ()
		{
			return APPLICATION_SKILL;
		}
	},

	methods: {
		edit ()
		{
			this.$refs.edit.openFan();
		}
	},
}
</script>
